export enum VehicleCompanyRole {
  ADMINISTRATOR = '1001',
  OWNER = '1002',
  MONITOR = '1003'
}